import { render, staticRenderFns } from "./businessHours.vue?vue&type=template&id=6dc54f5a&"
import script from "./businessHours.vue?vue&type=script&lang=js&"
export * from "./businessHours.vue?vue&type=script&lang=js&"
import style0 from "./businessHours.vue?vue&type=style&index=0&id=6dc54f5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports